import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DependentService } from "@core/services/dependent.service";
import { Subject, takeUntil } from 'rxjs';
import { Tutorial } from '@core/models/tutorial';

@Component({
  standalone: false,
  selector: 'app-registration-help-page',
  templateUrl: './registration-help-page.component.html',
  styleUrls: ['./registration-help-page.component.scss']
})
export class RegistrationHelpPageComponent implements OnInit, OnDestroy {

  constructor(public activeModal: NgbActiveModal, private toastr: ToastrService, private dependentService: DependentService

  ) { }
  // @Input() helpType: 'login' | 'forgotUsername' = 'login';
  @Input() helpType: 'login' | 'forgotUsername' | 'registration' = 'login';
  tutorials: Tutorial[] = [];
  selectedVideoUrl: string | null = null;
  selectedThumbnail: string | null = null;
  private unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.getTutorial();
  }

  copyPhoneNumber(phoneNumber: string) {
    navigator.clipboard.writeText(phoneNumber).then(() => {
      this.toastr.success('Phone number copied to clipboard!', 'Success');
    });
  }

  getTutorial(): void {
    this.dependentService.getTutorial().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (res) => {
        this.tutorials = res;
        this.setCorrectVideo();
      },
      error: (err) => {
        console.error('Error fetching tutorials', err);
      }
    })
  }

  setCorrectVideo() {
    if (!this.tutorials || this.tutorials.length === 0) return;

    if (this.helpType === 'login') {
      const login = this.tutorials.find(t => t.title.toLowerCase() === 'how to login');
      this.selectedVideoUrl = login ? login.videoUrl : null;
      this.selectedThumbnail = login ? login.thumbNail : null;
    }

    if (this.helpType === 'forgotUsername') {
      const forgot = this.tutorials.find(t => t.title.toLowerCase() === 'username recovery');
      this.selectedVideoUrl = forgot ? forgot.videoUrl : null;
      this.selectedThumbnail = forgot ? forgot.thumbNail : null;
    }

    if (this.helpType === 'registration') {
      const register = this.tutorials.find(t => t.title.toLowerCase() === 'self register');
      this.selectedVideoUrl = register ? register.videoUrl : null;
      this.selectedThumbnail = register ? register.thumbNail : null;
    }
  }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  
}


